import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-subscription-tag',
  standalone: true,
  imports: [NgIf, NgClass, BadgeModule ],
  templateUrl: './subscription-tag.component.html',
  // Phone: a long plan name wraps inside the tag instead of pushing the boxes and tables showing it wider than the
  // screen. `w-max` (max-content) never lets the tag shrink; fit-content is the same width while there is room.
  styles: [
    `
      @media (max-width: 768px) {
        :host {
          max-width: 100%;
        }

        :host > div {
          width: fit-content !important;
          max-width: 100%;
        }
      }
    `,
  ],
})
export class SubscriptionTagComponent<T> {
  @Input({ required: true }) bgColor!: string;
  @Input({ required: true }) fgColor!: string;
  @Input({ required: true }) planName!: string;
  @Input() available: string | null = null;
  @Input() selectable: boolean = false;
  @Output() onSelectEvent = new EventEmitter<void>();

  onSelectPlan() {
      this.onSelectEvent.emit();
  }
}
